import React from 'react';
import { Stack } from '@atlaskit/primitives';
import { PaypalPanelWithPrimitives } from './existing-paypal-payment-method';
import './paypal-login-panel.scss';

export type Paypal = {
  emailID?: string | null;
  isEditFlow?: boolean;
};

export const PaypalLoginPanel: React.FC<Paypal> = ({ emailID, isEditFlow }) =>
  emailID ? (
    <Stack space="space.200">
      <div>You’re currently logged in to:</div>
      <PaypalPanelWithPrimitives emailID={emailID} withBorder />
      {isEditFlow && (
        <p className="mb-8">
          Continue to log in to a different PayPal account. We’ll apply this change to all your subscriptions linked to
          PayPal.
        </p>
      )}
    </Stack>
  ) : (
    <div className="login-info">Continue to log in to your PayPal account.</div>
  );
